import { render, staticRenderFns } from "./PdfHeaderDocInfo.vue?vue&type=template&id=3ff4289e"
import script from "./PdfHeaderDocInfo.vue?vue&type=script&lang=ts"
export * from "./PdfHeaderDocInfo.vue?vue&type=script&lang=ts"
import style0 from "./PdfHeaderDocInfo.vue?vue&type=style&index=0&id=3ff4289e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports